import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from './queryKeys';
import { odontogramService } from '../services/api/odontogram-service.js';

// Dental charts are patient clinical data: never persisted to browser storage
// and not kept in memory once the consultation view is gone.
const CLINICAL_QUERY_META = { persist: false, isSensitive: true };

export function odontogramChartQueryOptions(appointmentId) {
  return {
    queryKey: queryKeys.odontogram.byAppointment(appointmentId),
    queryFn: ({ signal }) => odontogramService.fetchChart(appointmentId, { signal }),
    enabled: Boolean(appointmentId),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    meta: CLINICAL_QUERY_META,
  };
}

export function useOdontogramChart(appointmentId) {
  return useQuery(odontogramChartQueryOptions(appointmentId));
}

export function useSaveOdontogramChart(appointmentId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (chart) => odontogramService.saveChart(appointmentId, chart),
    meta: CLINICAL_QUERY_META,
    onSuccess: (saved) => {
      queryClient.setQueryData(queryKeys.odontogram.byAppointment(appointmentId), saved);
    },
  });
}
